import React from "react";
import { Link } from "react-router-dom";
import Wordmark from "../components/Brand/Wordmark";
import { useDocumentMeta } from "../lib/useDocumentMeta";

/*
 * Velaigal tombstone for the retired assessment/shared-test surface.
 * Covers `/test/share/*` and the legacy `/job-seeker/tests` link — both
 * pointed at MCQ/AI-interview flows that no longer exist now that hiring
 * runs through real-world task submissions instead. One button straight
 * to the public jobs list.
 */
const Tombstone: React.FC = () => {
  useDocumentMeta("Assessments have moved · Velaigal");

  return (
    <div className="min-h-screen w-full bg-cream flex items-center justify-center px-6">
      <div className="max-w-md text-center">
        <Wordmark variant="mark" size="lg" />
        <span className="label-editorial block mt-8">Discontinued</span>
        <h1 className="font-display text-3xl font-medium text-ink tracking-tight mt-4">
          Assessments have moved on.
        </h1>
        <span aria-hidden="true" className="block w-12 h-px bg-saffron mx-auto mt-6" />
        <p className="mt-6 text-base text-ink-secondary leading-relaxed">
          Assessments have been discontinued — Velaigal now hires through
          real-world task submissions. Browse open jobs instead.
        </p>

        <div className="mt-10">
          <Link to="/jobs" className="btn-primary">
            Browse open jobs
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Tombstone;
